/**
 * O vocabulário das punições — o NOME curto e a FRASE, num lugar só.
 *
 * Existe porque as duas telas divergiram em produção. O Início carimbava o selo fixo *"Restrito"* em
 * qualquer punição, e ao lado escrevia *"desvinculado: só um QR novo o traz de volta"* — duas
 * palavras para o mesmo fato, na mesma linha. Pior: *restrito* é o nome de OUTRA punição
 * (`alcance_restrito`), então a linha nomeava a punição errada.
 *
 * Cada punição tem dois textos, e eles não são intercambiáveis:
 *
 * - **`nome`** é o selo: curto, um substantivo, o que a coisa É.
 * - **`frase`** é o detalhe do Início: diz o que fazer, ou por que ninguém pode fazer nada. Ela fala
 *   com quem abriu a tela para trabalhar, não com quem quer o nome técnico.
 */
export interface Punicao {
  readonly nome: string;
  readonly frase: string;
}

export const PUNICOES: Record<string, Punicao> = {
  revogada: {
    nome: "Desvinculado",
    frase: "desvinculado: só um QR novo o traz de volta",
  },
  banido_temporario: {
    nome: "Bloqueado pelo WhatsApp",
    frase: "bloqueado pelo WhatsApp — não envie nada até o prazo terminar",
  },
  alcance_restrito: {
    nome: "Alcance restrito",
    frase: "o WhatsApp restringiu quantas pessoas novas ele pode abordar",
  },
  falha_de_conexao: {
    nome: "Conexão recusada",
    frase: "o WhatsApp recusou a conexão deste número",
  },
  sessao_substituida: {
    nome: "Sessão disputada",
    frase: "dois lugares usando as mesmas chaves",
  },
};

/** O selo. Cai no código cru em vez de inventar nome — punição nova aparece, e aparece legível. */
export function nomeDaPunicao(p: string): string {
  return PUNICOES[p]?.nome ?? p;
}

/** O detalhe do Início. O padrão é vago de propósito: melhor vago que errado. */
export function fraseDaPunicao(p: string): string {
  return PUNICOES[p]?.frase ?? "com restrição do WhatsApp";
}
